/**
 * @packageDocumentation
 * @module HackerAPI.Institution
 */
import { __extends } from "tslib";
import Address from "../address/address";
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
import Base from "../base/base";
/**
 * A data container for data related to an insitution with static methods for interfacing with
 * hackerapi.com
 * @class
 * @extends { HackerAPI.Base }
 */
var Institution = /** @class */ (function (_super) {
    __extends(Institution, _super);
    function Institution(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, name = _b.name, website = _b.website, country = _b.country, country_code = _b.country_code, countryCode = _b.countryCode, institution_type = _b.institution_type, institutionType = _b.institutionType, is_custom = _b.is_custom, isCustom = _b.isCustom, is_enabled = _b.is_enabled, isEnabled = _b.isEnabled, address = _b.address;
        var _this = _super.call(this) || this;
        /**
         * The institution ID of the institution
         * @type { number }
         */
        _this.id = id;
        /**
         * The name of the institution
         * @type { string }
         */
        _this.name = name;
        /**
         * The website affiliated with the institution
         * @type { string }
         */
        _this.website = website;
        /**
         * The country the institution is located in
         * @type { string }
         */
        _this.country = country;
        /**
         * The 2 character country code of the institution
         * @type { string }
         */
        _this.countryCode = country_code || countryCode;
        /**
         * The type of the institution (can be one of "post-secondary", "high_school", "middle_school")
         * @type { string }
         */
        _this.institutionType = institution_type || institutionType;
        /**
         * Whether or not the entry is a custom entry into the database or not
         * @type { boolean }
         */
        _this.isCustom = is_custom || isCustom;
        /**
         * Whether or not the institution is enabled (what that means I have no idea)
         * @type { boolean }
         */
        _this.isEnabled = is_enabled || isEnabled;
        /**
         * The address of the institution
         * @type { HackerAPI.Address }
         */
        _this.address = address ? new Address(address) : undefined;
        return _this;
    }
    /**
     * Fetches an institution from hackerapi
     * @param institution
     * @param institution.id
     * @returns
     */
    Institution.fetch = function (_a) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/institutions/" + id,
            method: "GET"
        }).then(function (data) { return new Institution(data); });
    };
    /**
     * Creates an institution on hackerapi
     * @param institution
     * @returns
     */
    Institution.create = function (institution) {
        return HackerAPIFetch({
            path: "/v2/institutions",
            method: "POST",
            body: institution.toHackerAPIFormat()
        }).then(function (data) { return new Institution(data); });
    };
    /**
     * Deletes an institution on hackerapi
     * @param institution
     * @param institution.id
     * @param token
     * @returns
     */
    Institution.delete = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/institutions/" + id,
            method: "DELETE",
            token: token
        });
    };
    return Institution;
}(Base));
export default Institution;
//# sourceMappingURL=institution.js.map